if (!customElements.get("lsg-ingredients")) customElements.define("lsg-ingredients", class LSGFaqGroup extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            parent: ".lsg-ingredients",
            contentItems: ".lsg-ingredients-content__item",
            faqButton: ".js-lsg-ingredients-button",
            subContentItems: ".lsg-ingredients-content__subitem",
            subFaqButton: ".js-lsg-ingredients-subbutton",
            image: ".js-ingredients-image"
        };
        this.parent = this.querySelector(this.selectors.parent);
        this.contentItems = this.querySelectorAll(this.selectors.contentItems);
        this.image = this.querySelectorAll(this.selectors.image);
        this.faqButton = this.querySelectorAll(this.selectors.faqButton);
        this.subFaqButton = this.querySelectorAll(this.selectors.subFaqButton);
        this.init();
    }

    closeAllFAQs() {
        this.image.forEach((el) => {
            el.classList.remove('is-show');
        });
        this.contentItems.forEach((el) => {
            el.setAttribute("data-opened", false);
            el.querySelector(".lsg-ingredients-content__question").setAttribute("aria-expanded", false);
            el.querySelector(".lsg-ingredients-content__answer").setAttribute("aria-hidden", true);
        });
    }

    closeAllSubFAQs(item) {
        item.parentNode.querySelectorAll(this.selectors.subContentItems).forEach((el) => {
            el.setAttribute("data-opened", false);
            el.querySelector(".lsg-ingredients-content__subquestion").setAttribute("aria-expanded", false);
            el.querySelector(".lsg-ingredients-content__subanswer").setAttribute("aria-hidden", true);
        });
    }

    // Toggle FAQ Item
    toggleFAQ(id) {
        let item = this.querySelector(`.lsg-ingredients-content__item[data-lsg-ingredients-id="${id}"]`);
        let image = this.querySelector(`${this.selectors.image}[data-id="${id}"]`);
        let status = item.getAttribute("data-opened");
        let close_others = this.querySelector(`.lsg-ingredients__content-wrapper`).getAttribute("data-close-others");
        if (close_others === "true") this.closeAllFAQs();
        if (status === "false") {
            image?.classList.add('is-show');
            item.setAttribute("data-opened", true);
            item.querySelector(".lsg-ingredients-content__question").setAttribute("aria-expanded", true);
            item.querySelector(".lsg-ingredients-content__answer").setAttribute("aria-hidden", false);
        } else {
            image?.classList.remove('is-show');
            item.setAttribute("data-opened", false);
            item.querySelector(".lsg-ingredients-content__question").setAttribute("aria-expanded", false);
            item.querySelector(".lsg-ingredients-content__answer").setAttribute("aria-hidden", true);
        }
    }

    subToggleFAQ(id) {
        let item = this.querySelector(`.lsg-ingredients-content__subitem[data-lsg-ingredients-id="${id}"]`);
        let status = item.getAttribute("data-opened");
        let close_others = this.querySelector(`.lsg-ingredients__content-wrapper`).getAttribute("data-close-others");
        if (close_others === "true") this.closeAllSubFAQs(item);
        if (status === "false") {
            item.setAttribute("data-opened", true);
            item.querySelector(".lsg-ingredients-content__subquestion").setAttribute("aria-expanded", true);
            item.querySelector(".lsg-ingredients-content__subanswer").setAttribute("aria-hidden", false);
        } else {
            item.setAttribute("data-opened", false);
            item.querySelector(".lsg-ingredients-content__subquestion").setAttribute("aria-expanded", false);
            item.querySelector(".lsg-ingredients-content__subanswer").setAttribute("aria-hidden", true);
        }
    }

    // Open First
    openFirstFAQ() {
        let open_first = this.querySelector(`.lsg-ingredients__content-wrapper`)?.getAttribute("data-open-first");
        if (open_first === "true") {
            let id = this.contentItems[0].getAttribute("data-lsg-ingredients-id");
            this.toggleFAQ(id);
            this.contentItems.forEach(item => {
                let el = item.querySelectorAll(this.selectors.subContentItems);
                if(el.length>0) {
                    this.subToggleFAQ(el[0].getAttribute("data-lsg-ingredients-id"));
                }
            })

        }
    }

    init() {
        this.closeAllFAQs();
        this.openFirstFAQ();
        // Handle Clicks
        this.faqButton.forEach((el) => {
            el.addEventListener("click", () => {
                const id = el.getAttribute("data-lsg-ingredients-id");
                this.toggleFAQ(id);
            });
        });
        this.subFaqButton.forEach((el) => {
            el.addEventListener("click", () => {
                const id = el.getAttribute("data-lsg-ingredients-id");
                this.subToggleFAQ(id);
            });
        });
        // Section selected in Theme Editor
        document.addEventListener("shopify:section:select", function (event) {
            const $parent = event.target;
            let check = $parent.querySelector(`${parent}`);
            if (check.length > 0) document(".lsg-ingredients-hero__filters").querySelector(`[data-filter-id="${$parent.find(`${parent}`).getAttribute("section-id")}"]`).click();
        });
        // Section loaded in Theme Editor
        document.addEventListener("shopify:section:load", function (event) {
            const $parent = $(event.target);
            let check = $parent.querySelector(this.selectors.parent);
            if (check != null) {
                this.closeAllFAQs();
                this.openFirstFAQ();
            }
        });
        // Block selected in Theme Editor
        document.addEventListener("shopify:block:select", function (event) {
            const $block = event.target;
            const $parent = $block.querySelector(this.selectors.parent);
            if ($parent != null) {
                this.closeAllFAQs();
                this.toggleFAQ($block.getAttribute("data-lsg-ingredients-id"));
            }
        });
    }
});

